import { createBrowserStorage } from '@thehotelsnetwork/browser-storage';

export default createBrowserStorage({
  secure: Boolean(import.meta.env?.PROD),
});
